import React from "react";
import { styled } from "@mui/material/styles";
import Link from "next/link";
import { CPagesPath } from "shared/models/const/pages-path";
import { useTranslations } from "next-intl";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useMediaQuery } from "@mui/material";
import SliderCollectionProperty from "@components/slider-collection-property";
import Button from "@components/Button";
import Typography from "@components/Typography";
import WsSectionTitleWithThinTitle from "@components/a1-refactor/typography/WsSectionTitle";
import WsSectionTitle from "@components/a1-refactor/typography/WsSectionTitle";

function CollectionHomeSection() {
  const translation = useTranslations("home.collection");
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Box
      position={"relative"}
      zIndex={2}
      sx={{
        backgroundColor: "var(--color-brand-cream-primary)",
      }}
    >
      <Collection>
        <Box className="container">
          <ColletionHeader>
            <CollectionLogo>
              {!isMobile && (
                <CollectionLogoImage
                  src="images/v2/logos/collection-01.png"
                  alt="Logo Remax Collection"
                />
              )}

              {isMobile && (
                <CollectionLogoImage
                  src="images/v2/logos/collection-02.png"
                  alt="Logo Remax Collection"
                />
              )}
            </CollectionLogo>

            <CollectionDescription>
              <WsSectionTitle
                title={`${translation("title")} ${translation("subtitle")}`}
                color="white"
              />

              <Description
                className="m-v-20"
                fontSize="--fs-body-small"
                color="--color-brand-bg-secondary"
                fontWeight={400}
              >
                {translation("description")}
              </Description>
            </CollectionDescription>
          </ColletionHeader>
          <SliderCollectionProperty></SliderCollectionProperty>
          <CollectionButton>
            <Link href={CPagesPath.es.collection} passHref>
              <Button component="a"> {translation("seeMore")}</Button>
            </Link>
          </CollectionButton>
        </Box>
      </Collection>
    </Box>
  );
}

export default CollectionHomeSection;

const Title = styled(Typography)`
  white-space: nowrap;
  font-size: 1.8rem;
`;

const Description = styled(Typography)`
  font-size: 1rem;
`;

const CollectionButton = styled("article")`
  width: 100%;
  margin: auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
`;

const Collection = styled(Grid)`
  position: relative;
  z-index: 2;
  width: 100%;
  background-color: var(--color-brand-blue-collection-main);
  border-radius: 150px 0 0 0;
  padding-top: 150px;
  padding-bottom: 100px;

  @media screen and (max-width: 991px) {
    padding-bottom: 50px;
    padding-top: 50px;
  }

  @media screen and (max-width: 767px) {
    border-radius: 0;
  }

  @media screen and (max-width: 575px) {
    padding-top: 120px;
  }

  @media screen and (max-width: 485px) {
    padding-top: 90px;
  }
`;

const ColletionHeader = styled("section")`
  display: flex;
  margin-bottom: 70px;

  @media screen and (max-width: 991px) {
    flex-wrap: wrap;
  }

  @media screen and (max-width: 575px) {
    margin-bottom: 50px;
  }
`;

const CollectionLogo = styled("div")`
  width: 40%;
  align-self: center;
  text-align: center;

  @media screen and (max-width: 991px) {
    margin-bottom: 30px;
    width: 100%;
    max-width: 550px;
    margin-right: auto;
    margin-left: auto;
    padding: 0px 20px;
  }
`;

const CollectionLogoImage = styled("img")`
  width: 180px;
  height: auto;
  @media screen and (max-width: 991px) {
    width: 100%;
    max-width: 200px;
  }
`;

const CollectionDescription = styled("div")`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 2rem;

  @media screen and (max-width: 991px) {
    width: 100%;
    max-width: 550px;
    margin-right: auto;
    margin-left: auto;
    padding: 0px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;
